/**
 * Axios options for a poll that must skip the browser's HTTP cache. XHR can't skip it, fetch can; CloudFront ignores
 * the no-cache some browsers send with it. Axios's fetch adapter adds `User-Agent: axios/x`, which Firefox and Safari
 * send and preflight, and the API's CORS refuses.
 */
export const PAST_BROWSER_CACHE = {
    adapter: 'fetch',
    fetchOptions: { cache: 'no-store' },
    headers: { 'User-Agent': false },
} as const;
